import { radioClasses, styled } from '@mui/material';
import { Props } from './types';
import { SIZES } from '../../theme/overrides/Radio';

export const StyledRadioIcon = styled('span')<{
  size: NonNullable<Props['size']>;
}>(({ theme, size }) => ({
  borderRadius: '50%',
  'input:checked:disabled ~ &': {
    width: SIZES[size].width,
    height: SIZES[size].height,
    boxShadow: `0 0 0px 1px ${theme.palette.foreground.quinary}, inset 0 0 0 5px ${theme.palette.background.disabled}, inset 0 -1px 0  ${theme.palette.background.disabled}`,
    backgroundColor: theme.palette.foreground.quinary,
  },
  'input:checked:disabled ~ &::before': {
    backgroundImage: `radial-gradient(${theme.palette.foreground.quinary},${theme.palette.foreground.quinary} 28%,transparent 32%)`,
  },
  'input:disabled ~ &': {
    width: SIZES[size].width,
    height: SIZES[size].height,
    boxShadow: `inset 0 0 0 1px ${theme.palette.foreground.quinary}, inset 0 -1px 0  ${theme.palette.foreground.quinary}`,
    backgroundColor: theme.palette.background.disabled,
  },
}));

export const StyledCheckedRadioIcon = styled(StyledRadioIcon)<{
  size: NonNullable<Props['size']>;
}>(({ theme, color, size }) => ({
  backgroundColor: color,
  '&::before': {
    display: 'block',
    width: SIZES[size].width,
    height: SIZES[size].height,
    backgroundImage: `radial-gradient(${theme.palette.common.white},${theme.palette.common.white} 28%,transparent 32%)`,
    content: '""',
  },
  'input:hover ~ &': {
    backgroundColor: color,
  },
  [`.${radioClasses.disabled}`]: {
    width: SIZES[size].width,
    height: SIZES[size].height,
    boxShadow: `inset 0 0 0 1px ${theme.palette.foreground.quinary}, inset 0 -1px 0  ${theme.palette.foreground.quinary}`,
    backgroundColor: theme.palette.background.disabled,
  },
}));
